<template>
  <helper-input-btn>
    <erp-input
        ref="input"
        @input="__set"
        slot="input"
        simple-border
        v-model="description"
        :size="size"
        @keydown.enter="search"
        readonly
    >
      <u-popover v-if="this.findedData" hover :hover-delay="500" class="popover-user-profile" anchor="bottom middle"
                 self="top middle" :offset="[10, 10]">
        <div class="wrapper bg-white font-12">
          <div class="row">
            <div class="col m-r">ID: <strong>{{findedData.id}}</strong></div>
          </div>
          <div class="row m-t">
            <div class="col m-r">Nome: <strong>{{findedData.name}}</strong></div>
          </div>
          <div class="m-t">
            <e-btn label="Acessar configuração de checklist" />
          </div>
        </div>
      </u-popover>
    </erp-input>
    <div class="erp-icon-float" style="z-index: 4; position: relative"><a @click="search"><i class="erp-icon search min"></i> </a></div>
    <img v-if="findedDataObj && findedDataObj.image && findedDataObj.image.thumb" :src="findedDataObj.image.thumb" style="height: 20px" />
    <!--    <u-icon name="plus-circle" type="fa" icon-style="light" class="m-l-xs cursor-pointer" />-->
  </helper-input-btn>
</template>

<script>
import InputMixin from '../../../../reuse/input/mixin'
import {HelperInputBtn} from 'uloc-vue-plugin-erp'
import {UPopover} from 'uloc-vue'
import search from '@/components/bem/components/include/search/SearchConfigChecklist'

export default {
  name: 'ConfigChecklistInput',
  props: ['size'],
  mixins: [InputMixin],
  data () {
    return {
      findedData: this.findedDataObj
    }
  },
  watch: {
    findedData (v) {
      this.$emit('updateSelected', v)
    },
    findedDataObj (v) {
      this.adjust()
    }
  },
  mounted () {
    this.adjust()
  },
  components: {HelperInputBtn, UPopover},
  methods: {
    adjust () {
      if (this.findedDataObj) {
        this.description = this.findedDataObj.id + ' - ' + this.findedDataObj.nome
      }
    },
    __updateInternal () {
      this.updateInternal((v) => v.id + ' - ' + v.pessoa.name)
    },
    search: search
  }
}
</script>
